module.exports = __webpack_public_path__ + "img/illustrations-rocket.9a3108c4.svg";